const appointments = [
  {
    title: 'John',
    startDate: new Date(2022, 1, 27, 12, 11),
    endDate: new Date(2022, 1, 27, 13, 0),
    id: 1,
  }, {
    title: 'Ed',
    startDate: new Date(2022, 1, 28, 14, 30),
    endDate: new Date(2022, 1, 28, 15, 35),
    id: 2,
  }, {
    title: 'Sam',
    startDate: new Date(2022, 2, 1, 10, 0),
    endDate: new Date(2022, 2, 1, 14, 0),
    id: 3,
  }, {
    title: 'Joe',
    startDate: new Date(2022, 2, 2, 14, 30),
    endDate: new Date(2022, 2, 2, 16, 45),
    id: 5,
  }, {
    title: 'Ally',
    startDate: new Date(2022, 2, 3, 9, 45),
    endDate: new Date(2022, 2, 3, 11, 15),
    id: 6,
  }, {
    title: 'Anna',
    startDate: new Date(2022, 2, 4, 12, 0),
    endDate: new Date(2022, 2, 4, 14, 0),
    id: 7,
  }, {
    title: 'Bob',
    startDate: new Date(2022, 2, 5, 15, 15),
    endDate: new Date(2022, 2, 5, 16, 30),
    id: 8,
  }, {
    title: 'Bill',
    startDate: new Date(2022, 2, 6, 11, 0),
    endDate: new Date(2022, 2, 6, 15, 0),
    id: 9,
  }, {
    title: 'Zach',
    startDate: new Date(2022, 2, 7, 11, 0),
    endDate: new Date(2022, 2, 7, 13, 30),
    id: 10,
  }, {
    title: 'Avery',
    startDate: new Date(2022, 2, 8, 14, 0),
    endDate: new Date(2022, 2, 8, 15, 30),
    id: 11,
  }, {
    title: 'Ron',
    startDate: new Date(2022, 2, 9, 10, 0),
    endDate: new Date(2022, 2, 9, 11, 30),
    id: 12,
  },
];

export default appointments;
